export {default as VtxSearchMap} from './VtxSearchMap';
export {default} from './VtxSearchMap';